export const KloverPointsActions = {
  ACTION_CONV: 'postbackEvent',
  // SUCCESS_URL: 'successUrl', // No longer displayed
  CLICK_THROUGH: 'click',
};

export const PointsChangeType = {
  promo: 'Promo',
  onetime: 'One-time',
};
